"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToggle = useToggle;
exports.useOnClickOutside = useOnClickOutside;
const react_1 = require("react");
/**
 * Create and return a boolean state variable and accompanying toggle helper.
 */
function useToggle(initialValue = false) {
    const [value, setValue] = (0, react_1.useState)(initialValue);
    const toggle = () => {
        setValue((v) => !v);
    };
    return [value, toggle];
}
/**
 * Generic handler to listen for clicks outside of the ref'd component
 */
function useOnClickOutside(ref, handler) {
    (0, react_1.useEffect)(() => {
        const listener = (event) => {
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [ref, handler]);
}
